/**
 * Created by andreyna on 8/15/2017.
 */
import BaseModelComponent from '../../../base/base_model_component';
import { FP_INDICATOR_CLASSES, DISPLAY_CONSTRAINT } from './fp_indicator_consts';
import _ from '../../../utils/underscore';
import { IAlteredFreePlayVoucher } from '../voucher/free_play_voucher_consts';

export default class FPIndicatorComponentModel extends BaseModelComponent {
    /**
     * @static
     * @type {string}
     */
    static CLASS = 'FPIndicatorComponentModel';

    private _fpData: IAlteredFreePlayVoucher[];
    private _isEnabledState: boolean;
    private _gameTypeID: number;
    private _indicatorIcons: any;
    private _openMode: string;
    private _openPriority: number;
    private _openDirection: string;
    private _displayConstraint: string;
    private _freePlayID: string;
    private _analytics: any;
    private _onSelectedFn: Function;
    private _isSelected: boolean;


    /**
     *
     * @param params
     */
    init(params: any = {}) {
        super.init(params);
        this._setGameTypeID(params.gameTypeID)
            ._setIndicatorIcons(params.indicatorIcons)
            ._setFreePlayOpenMode(params.openMode)
            ._setOpenPriority(params.openPriority)
            ._setOpenDirection(params.openDirection)
            ._setDisplayConstraint(params.displayConstraint)
            ._setFreePlayID(params.freePlayID)
            ._setOnSelected(params.onSelected)
            .setIsSelected(params.isSelected)
            ._setAnalytics(params.analytics);
    }


    /**
     * Set free plays
     * @param fpData
     * @returns {FPIndicatorComponentModel}
     */
    setFreePlayData(fpData) {
        this._fpData = fpData;
        return this;
    }


    /**
     * Get free play data
     * @returns {*}
     */
    getFreePlayData() {
        return this._fpData;
    }


    /**
     * Set if state enabled
     * @param isEnabled
     */
    setIsEnabledState(isEnabled) {
        this._isEnabledState = isEnabled;
    }

    /**
     * Get if state is enabled
     * @returns {*}
     */
    getIsEnabledState() {
        return this._isEnabledState;
    }

    /**
     * Set GameTypeID
     * @param gameTypeID
     * @returns {FPIndicatorComponentModel}
     * @private
     */
    private _setGameTypeID(gameTypeID) {
        this._gameTypeID = gameTypeID;
        return this;
    }


    /**
     * Set css class for indicator on / off items
     * @param indicatorIcons
     * @returns {FPIndicatorComponentModel}
     * @private
     */
    private _setIndicatorIcons(indicatorIcons) {
        const defaultIcons = {
            enabled: FP_INDICATOR_CLASSES.ICON_ENABLED_BACKGROUND,
            selected: FP_INDICATOR_CLASSES.ICON_ENABLED_BACKGROUND,
            disabled: FP_INDICATOR_CLASSES.ICON_DISABLED_BACKGROUND
        };

        this._indicatorIcons = Object.assign({}, defaultIcons, _.isObject(indicatorIcons) ? indicatorIcons : _.safeJSON(indicatorIcons));
        return this;
    }

    /**
     * Define open mode for FreePlay message when click on icon
     * @param openMode
     * @returns {FPIndicatorComponentModel}
     * @private
     */
    private _setFreePlayOpenMode(openMode) {
        this._openMode = openMode;
        return this;
    }


    /**
     * Set priority level that can be passed tp FreePlay service in order to open FreePlay message in lightbox with specified overlay priority level
     * @param openPriority
     * @returns {FPIndicatorComponentModel}
     * @private
     */
    private _setOpenPriority(openPriority) {
        this._openPriority = openPriority;
        return this;
    }


    /**
     * Set the initial direction that free play message should be opened with
     * @param openDirection
     * @returns {FPIndicatorComponentModel}
     * @private
     */
    private _setOpenDirection(openDirection) {
        this._openDirection = openDirection;
        return this;
    }


    /**
     * Set filter to make indicator enabled or disabled
     * @param filterBy
     * @returns {FPIndicatorComponentModel}
     * @private
     */
    private _setDisplayConstraint(displayConstraint = DISPLAY_CONSTRAINT) {
        this._displayConstraint = displayConstraint;
        return this;
    }


    /**
     * Set free play ID that indicator works with
     * @param isFreePlay
     * @private
     */
    private _setFreePlayID(freePlayID) {
        this._freePlayID = freePlayID;
        return this;
    }

    /**
     * Set analytics object to be send on FreePlay button click
     * @param analytics
     * @returns {FPIndicatorComponentModel}
     * @private
     */
    private _setAnalytics(analytics) {
        this._analytics = _.safeJSON(analytics, {});
        return this;
    }

    /**
     * Set callback on Selected
     * @param callback
     * @returns {FPIndicatorComponentModel}
     * @private
     */
    private _setOnSelected(callback) {
        this._onSelectedFn = callback;
        return this;
    }


    /**
     * Set is indicator selected
     * @param isSelected
     * @returns {FPIndicatorComponentModel}
     */
    setIsSelected(isSelected = false) {
        this._isSelected = isSelected;
        return this;
    }


    /**
     * Get GameTypeID
     * If it's defined, indicator will be on only if there is voucher with specified game
     * @returns {*}
     */
    getGameTypeID() {
        return this._gameTypeID;
    }


    /**
     * Get indicator icons.
     * If defined, the default css class for icons will be replaced
     * @returns {*}
     */
    getIndicatorIcons() {
        return this._indicatorIcons;
    }

    /**
     * Get open mode for FreePlay message
     * @returns {*}
     */
    getOpenMode() {
        return this._openMode;
    }


    /**
     * Get priority level that can be passed to FreePlay service in order to open FreePlay message in lightbox with specified overlay priority level
     * @returns {*}
     */
    getOpenPriority() {
        return this._openPriority;
    }


    /**
     * Get the initial direction that free play message should be opened with
     * @returns {*}
     */
    getOpenDirection() {
        return this._openDirection;
    }


    /**
     * Get filter by
     * @returns {string|*}
     */
    getDisplayConstraints() {
        return this._displayConstraint;
    }


    /**
     * Get FreePlayID that indicator works with
     * @returns {boolean|*}
     */
    getFreePlayID() {
        return this._freePlayID;
    }

    /**
     * Add default selectors to style selector passed to components
     * @returns {any}
     */
    getStyleSelectors() {
        return Object.assign({}, { active: FP_INDICATOR_CLASSES.ACTIVE }, super.getStyleSelectors());
    }


    /**
     * Get analytics object to be send on FreePlay button click
     * @returns {{category: string, action: string}|*}
     */
    getAnalytics() {
        return this._analytics;
    }


    /**
     * Get if indicator is selected
     * @returns {*}
     */
    getIsSelected() {
        return this._isSelected;
    }


    /**
     * Get onSelected callback function
     * @returns {*}
     */
    getOnSelectedFn() {
        return this._onSelectedFn;
    }
}
